export default [
  {
    path: '/discussions',
    name: 'discussions#index',
    component: () => import(/* webpackChunkName: "discussions/index" */ '@views/discussion-board/index'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/discussions/manage',
    name: 'discussions#manage',
    component: () => import(/* webpackChunkName: "discussions/manage" */ '@views/discussion-board/manage'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/discussions/questions',
    name: 'discussions#questions',
    component: () => import(/* webpackChunkName: "discussions/questions" */ '@views/discussion-board/questions'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/discussions/:boardId',
    name: 'discussions#board',
    component: () => import(/* webpackChunkName: "discussions/board" */ '@views/discussion-board/show'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/discussions/:boardId/threads/:threadId',
    name: 'discussions#thread',
    component: () => import(/* webpackChunkName: "discussions/thread" */ '@views/discussion-board/thread'),
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  // Links sent before the move to /discussions
  {
    path: '/discussion-board/:rest(.*)*',
    redirect: to => to.fullPath.replace(/^\/discussion-board/, '/discussions'),
  },
];
